<template>
    <div class="header-bar-medical-device-item-wrapper">
        <v-list class="width-full">
            <v-radio-group
                style="padding-top: 10px;padding-bottom: 10px"
                class="account-settings"
                v-model="selectedTheme"
            >
                <div
                    class="radio-button-wrapper"
                    @click="changeTheme(theme.value)"
                    v-for="theme in getThemeList"
                >
                    <div class="icon-text-wrapper">
                        <light-theme-icon v-if="theme.value === lightTheme"/>
                        <dark-theme-icon v-if="theme.value === darkTheme"/>
                        <high-contrast-light-icon v-if="theme.value === lightThemeHighContrast"/>
                        <high-contrast-dark-icon v-if="theme.value === darkThemeHighContrast"/>
                        <p style="margin: 0 0 0 15px;">{{theme.name}}</p>
                    </div>

                    <v-radio
                        :key="theme.value + 'responsive'"
                        :value="theme.value"
                        :id="theme.value"
                    ></v-radio>
                </div>

            </v-radio-group>

            <v-divider v-if="getAppPropertyValueArray('GUI_VARIANTS_AVAILABLE').length === 2 && !isPFI && showSwitches && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'"></v-divider>

            <v-list-tile v-if="getAppPropertyValueArray('GUI_VARIANTS_AVAILABLE').length === 2 && !isPFI && showSwitches && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'">
                <v-list-tile-content
                    class="switch-action-wrapper"
                >
                    {{text('api.pro.priorityList')}}
                    <BaseSwitch v-model="mustShowAssessmentList" elem-id="togglePriorityListSmallDisplay"/>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider v-if="!isPFI && showSwitches && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'"></v-divider>

            <v-list-tile v-if="!isPFI && showSwitches && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'">
                <v-list-tile-content
                    class="switch-action-wrapper"
                >
                    {{text('api.pro.toggleEvaluationPage')}}
                    <BaseSwitch v-model="mustShowEvaluationPage" elem-id="toggleMustShowEvaluationPageSmallDisplay"/>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile v-if="appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'">
                <v-list-tile-content class="language-dropdown-container">
                    <v-select
                        :items="languageListForDropdown"
                        item-text="name"
                        item-value="key"
                        v-model="selectedLang"
                        single-line
                        auto
                        append-icon="keyboard_arrow_down"
                        hide-details
                        class="language-option no-padding-top"
                        @input="changeLanguage"
                        color="primary"
                    ></v-select>
                </v-list-tile-content>
            </v-list-tile>

        </v-list>
    </div>
</template>

<script>
import BaseSwitch from "./BaseSwitch";
import {mapGetters} from "vuex";
import Vue from "vue";
import THEMES from "../../constants/themes";
import DarkThemeIcon from "../svg/shared/darkThemeIcon";
import HighContrastLightIcon from "../svg/shared/highContrastLightIcon";
import HighContrastDarkIcon from "../svg/shared/highContrastDarkIcon";
import LightThemeIcon from "../svg/shared/lightThemeIcon";
export default {
    name: "SettingsList",
    components: {LightThemeIcon, HighContrastDarkIcon, HighContrastLightIcon, DarkThemeIcon, BaseSwitch},
    props: {
        // Provides the application type that comes with the app properties
        appType: {
            type: String,
            default: null,
        },
        // TODO Do we need this?
        getRole: {
            type: String,
            default: ' '
        },
        // We need to provide the boolean that opens and closes the sidenav in order to set the checked radio button
        // with our personal svg
        sideNav: {
            type: Boolean,
            default: false,
        },
        // We set this to true to hide the mustShowAssessmentList and mustShowEvaluationPage switches
        isPFI: {
            type: Boolean,
            default: false
        },
        showSwitches: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        ...mapGetters({
            languageList: 'TranslationStore/getLanguageList',
            getThemeList: 'ThemeStore/getThemeList',
            getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray'
        }),
        languageListForDropdown() {

            let langsForDropdown = [];
            this.languageList.forEach((langKey) => {
                langsForDropdown.push({
                    key: langKey,
                    name: this.text("api.language.name." + langKey)
                });
            });
            return langsForDropdown;
        },

        selectedLang: {
            get () {
                return this.$store.state["TranslationStore"].selectedLanguage;
            },
            set (newVal) {
                this.$store.commit('TranslationStore/setSelectedLanguage', newVal);
            }
        },
        selectedTheme: {
            get() {
                return this.$store.state["ThemeStore"].theme;
            },

            set() {

            }
        },
        mustShowAssessmentList: {
            get() {
                return this.$store.getters['SymptomsQuestionsStore/getMustShowAssessmentList'];
            },
            set(newVal) {
                this.submitChangeMustShowAssessmentList(newVal)
            }

        },
        mustShowEvaluationPage: {
            get() {
                return this.$store.getters['TranslationStore/getMustShowEvaluationPage'];
            },
            set(newVal) {
                this.submitChangeMustShowEvaluationPage(newVal);
            }

        },
    },
    data() {
        return {
            radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
            arrowDownPlugin: Vue.ArrowDown.arrowDownSvg,
            lightTheme: THEMES.LIGHT.VALUE,
            darkTheme: THEMES.DARK.VALUE,
            lightThemeHighContrast: THEMES.LIGHT_HIGH_CONTRAST.VALUE,
            darkThemeHighContrast: THEMES.DARK_HIGH_CONTRAST.VALUE
        }
    },
    methods :{
        changeLanguage(newLang) {
            this.$store.dispatch("TranslationStore/submitLanguageChange", newLang).then((response) => {
                window.location.reload();
            });
        },

        changeTheme(newVal) {
            let options = {};
            options.newThemeValue = newVal;
            this.$emit('closeSideNav');
            options.isPFI = this.isPFI;
            this.$store.dispatch("ThemeStore/selectTheme", options) ;
        },
        submitChangeMustShowEvaluationPage(value) {
            if (value) {
                this.$store.dispatch("TranslationStore/submitEvaluationPageType", true).then((response) => {

                });
            } else {
                this.$store.dispatch("TranslationStore/submitEvaluationPageType", false).then((response) => {

                });
            }
        },
        submitChangeMustShowAssessmentList(value) {
            if (value) {
                this.$store.dispatch("SymptomsQuestionsStore/submitAssessmentType", true).then((response) => {

                });
            } else {
                this.$store.dispatch("SymptomsQuestionsStore/submitAssessmentType", false).then((response) => {

                });
            }
            if (this.$router.currentRoute.path === '/symptoms-list' || this.$router.currentRoute.path === '/symptoms-questions') {

                if (value) {
                    this.$router.push('/symptoms-list');
                } else {
                    this.$router.push('/symptoms-questions');
                }
                this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', value);

            } else if (this.$router.currentRoute.path === '/assessment-start' || this.$router.currentRoute.path === '/assessment-start-list') {

                if (value) {
                    this.$router.push('/assessment-start-list');
                } else {
                    this.$router.push('/assessment-start');
                }
                this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', value);

            } else {
                this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', value);
            }

        }
    },
    mounted() {
        let selectedInputIcon = document.getElementsByClassName('language-option');
        if (selectedInputIcon.length !== 0) {
            let selectLanguage = selectedInputIcon[0].getElementsByClassName('input-group__append-icon');
            selectLanguage[0].innerHTML = this.arrowDownPlugin();
        }
    },
    watch:{
        sideNav(newVal, oldVal) {
            if(newVal) {
                let radio = document.querySelector('.mobile-menu.navigation-drawer .icon--radio');
                radio.innerHTML = this.radioButtonPlugin();
            }
        },
    }

}
</script>



// WEBPACK FOOTER //
// src/common/components/shared/SettingsList.vue